<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card mt-2">
				<div class="card-body">
		
					<button class="btn btn-sm btn-block btn-primary mt-4 mb-4" @click="readCode" >INICIAR CONTROL</button>
					
					<router-link v-if="loggedUser.can_transfer" tag="a" to="/transfers/start" class="btn btn-sm btn-block btn-primary mt-4 mb-4">INICIAR TRASLADO</router-link>
					
					<router-link v-if="loggedUser.can_transfer" tag="a" to="/transfers/end" class="btn btn-sm btn-block btn-primary mt-4 mb-4">CERRAR TRASLADO</router-link>
					
					<div class="row ">
						<div class="col col-12 ">
							<div class="bg-white">
								<b-tabs content-class="" @activate-tab="activateTab" >

									<b-tab title="A pre entregar">
										<div class="p-4">
											<div class="d-flex justify-content-between align-items-center">
												<h5>Vehículos pendientes de pre entrega</h5>
											</div>

											<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>

											<table class="table table-clickeable mt-4" v-if="!loadingTab && carsToPreDelivery.length>0">
												<tr class="table-head">
													<td>Chasis</td>
													<td>Vehículo</td>
													<td>Cliente</td>
													<td></td>
												</tr>
												<tr v-for="item of carsToPreDelivery" :key="item.id" @click="readCode(item.id)" >
													<td>{{item.chassis_number}}</td>
													<td>
														<div class="tc">
															<span class="text-primary">{{item.brand.title}}</span>
															<span >{{item.model}}</span>
														</div>
													</td>
													<td>
														<div class="tc">
															<span class="text-primary">{{item.client.name}}</span>
															<span >{{item.client.business_name}}</span>
														</div>
													</td>
													<td>
														<div class="tc" v-if="item.pre_delivery_requested_at">
															<span>Solicitada el</span>
															<span>
																{{item.pre_delivery_requested_at | moment("DD-MM-YYYY")}}
															</span>
														</div>
													</td>
												</tr>
											</table>
											<div class="alert alert-light text-center" v-if="!loadingTab && carsToPreDelivery.length==0">No se han encontrado vehículos a pre entregar</div>
										</div>
									</b-tab>
									
									<b-tab title="Sin lugar asignado">
										<div class="p-4">
											<h5>Vehículos sin lugar asignado</h5>
											
											<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>

											<table class="table table-clickeable mt-4" v-if="!loadingTab && carsWithoutSlot.length>0">
												<tr class="table-head">
													<td>Chasis</td>
													<td>Vehículo</td>
													<td>Cliente</td>
													<td>Estado</td>
												</tr>
												
												<tr v-for="item of carsWithoutSlot" :key="item.id" @click="readCode(item.id)">
													<td>{{item.chassis_number}}</td>
													<td>
														<div class="tc">
															<span class="text-primary">{{item.brand.title}}</span>
															<span >{{item.model}}</span>
														</div>
													</td>
													<td>
														<div class="tc">
															<span class="text-primary">{{item.client.name}}</span>
															<span >{{item.client.business_name}}</span>
														</div>
													</td>
													<td>
														<div class="tc">
															<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
															<span v-if="item.delivery_scheduled_at" style="margin-left: 15px;">{{item.delivery_scheduled_at | moment("DD-MM-YYYY")}}</span>
														</div>
													</td>
												</tr>
											</table>
											<div class="alert alert-light text-center" v-if="!loadingTab && carsWithoutSlot.length==0" >No se han encontrado vehículos sin lugar asignado</div>
										</div>
									</b-tab>

									<b-tab title="Traslados en curso" v-if="loggedUser.can_transfer">
										<div class="p-4">
											<h5>Traslados abiertos</h5>
											
											<div class="alert alert-light text-center mt-3" v-if="loadingTab">Cargando...</div>

											<table class="table table-clickeable mt-4" v-if="!loadingTab && transfers.length>0">
												<tr class="table-head">
													<td>Chasis</td>
													<td>Vehículo</td>
													<td>Iniciado en</td>
													<td>Estado</td>
												</tr>
												
												<tr v-for="item of transfers" :key="item.id" >
													<td>{{item.chassis_number}}</td>
													<td>
														<div class="tc">
															<span class="text-primary">{{item.brand.title}}</span>
															<span >{{item.model}}</span>
														</div>
													</td>
													<td>
														<div class="tc">
															<span >{{item.location}}</span>
														</div>
													</td>
													<td>
														<div class="tc">
															<span><div class="car-status-point DELIVERED"></div>{{item.statusText}}</span>
														</div>
													</td>
												</tr>
											</table>
											<div class="alert alert-light text-center" v-if="!loadingTab && transfers.length==0" >No se han encontrado traslados en curso</div>
										</div>
									</b-tab>

								</b-tabs>
							</div>

						</div>

					</div>

				</div>
			</div>
		</div>

		<ReadCode ref="readCode"></ReadCode>
		
		
		
	</div>

</div>
</template>

<script>
import gql from 'graphql-tag'
// import listMixins from '@/mixins/listMixins'
import { mapGetters } from 'vuex'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import ReadCode from '@/views/controls/ReadCode'

export default {
	name: 'cars',
	components:{
		Navbar,
		ReadCode,
		Loader,
	},
	computed:{
		...mapGetters(['loggedUser'])
	},
	// mixins:[listMixins],
	data () {
		return {
			loading: false,
			loadingTab:false,
			data:null,
			carsWithoutSlot: [],
			carsToPreDelivery:[],
			transfers:[]
		}
	},
	beforeMount(){
		// this.load();
		this.loadCarsWithoutSlot()
	},
	methods:{
		activateTab(newTabIndex ){
			if(newTabIndex == 0){ this.loadCarsWithoutSlot() }
			if(newTabIndex == 1){ this.loadCarsToPreDelivery() }
			if(newTabIndex == 2){ this.loadTranfers() }
		},
		readCode(carId){
			this.$refs.readCode.open(carId)
		},
		load(){
			this.$apollo.query({
				query: gql`query {
					adminDashboard {
						totals{
							carsPreAdmited
							carsInCustomsDeposit
							carsCustomsDispatchPending
							carsInNationalDeposit
							carsPreDeliveryPending
							carsPreDeliveryDone
							carsDeliveryScheduled
							carsDeliveryRequested
						}
					}
				}`,
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.data = data.data.adminDashboard;
				this.loading = false
			});
		},
		loadCarsWithoutSlot(){
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String){
					cars ( first: $first, status: $status ){
						data{
							id
							chassis_number
							model
							brand{ title }
							client{ name business_name }
							status
							statusText
							delivery_scheduled_at
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'WITHOUT_SLOT'
				},
			})
			.then((data) => {
				this.carsWithoutSlot = data.data.cars.data;
				this.loadingTab = false
			});
		},
		loadCarsToPreDelivery(){
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String){
					cars ( first: $first, status: $status ){
						data{
							id
							chassis_number
							model
							brand{ title }
							client{ name business_name }
							pre_delivery_requested_at
							status
							statusText
							
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'PRE_DELIVERY_PENDING'
				},
			})
			.then((data) => {
				this.carsToPreDelivery = data.data.cars.data;
				this.loadingTab = false
			});
		},
		loadTranfers(){
			this.loadingTab = true
			this.$apollo.query({
				query: gql`query ($first: Int!, $status: String){
					transfers ( first: $first, status: $status ){
						data{
							id
							chassis_number
							model
							brand{ title }
							location
							status
							statusText
						}
					}
				}`,
				fetchPolicy: 'no-cache',
				variables: {
					first: 10,
					status: 'ON_COURSE'
				},
			})
			.then((data) => {
				this.transfers = data.data.transfers.data;
				this.loadingTab = false
			});
		},
		
	}
}


</script>

<style>

</style>
